// V1-COMPAT: stands in for qwoted-rails views_shared/app/javascript/scripts/qahoy.js under the
// `views_shared/app/javascript/scripts/qahoy` webpack alias (config/webpack/base.js), the same way
// v2_authentication.js and vlog.js stand in for their V2 originals.
//
// The real module configures ahoy.js to POST events to "/account/api/ahoy/events", a V2 Rails
// route. Copied trees mounted in V1 send that same-origin, so it reaches V1, which has no such
// route, and every tracked interaction answers 404. V1 already records this traffic through its own
// Ahoy install, so a second, broken client-side tracker adds nothing -- the V2-port trees are
// simply not tracked here.
//
// `track` is the only method the copied trees call (checked across the whole copied closure), but
// this keeps the shape of the original -- a default export plus `window.qahoy` -- so a copied file
// that reaches for either still finds something rather than throwing. Dies with the V1 bridge; if
// this traffic ever needs tracking, the fix is a V1-side events endpoint, not reviving the V2 URL.
const qahoy = {
  track: () => {},
};

window.qahoy = qahoy;

export default qahoy;
